import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import useScreenSize from "../../../hooks/useScreenSize";

import "../../../styles/landingPage/how-to.scss";

import { ReactComponent as JoinUsSvg } from "../../../assets/home/howTo/join-us.svg";
import { ReactComponent as UploadSvg } from "../../../assets/home/howTo/upload.svg";
import { ReactComponent as TenderSvg } from "../../../assets/home/howTo/tender.svg";
import { ReactComponent as ArrowRightSvg } from "../../../assets/icons/arrow-right-thin.svg";
import communityGif from "../../../assets/home/community.gif";
import shareGif from "../../../assets/home/share.gif";
import auctionGif from "../../../assets/home/auction.gif";

import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const HowTo = (props) => {
  const { screenSize } = useScreenSize();
  const { isAuth, toggleAuthModal, getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.footer);

  const navigate = useNavigate();

  const handleJoinUs = () => {
    if (isAuth) {
      toast.info("You're already logged in");
      return;
    }

    if (!isAuth) {
      toggleAuthModal(true, "signup");
      return;
    }
  };

  const handleShareProject = () => {
    if (isAuth) {
      navigate("/profile/new-project");
      return;
    }

    if (!isAuth) {
      toggleAuthModal(true, "signup", "/profile/new-project");
      return;
    }
  };

  const options = [
    {
      title: Translation("How to Join Us"),
      desc: Translation("If you wish to join us but don't know how to do so,"),
      sub: Translation(
        "As a member, you get benefits: support, showcasing & selling projects."
      ),
      cta: Translation("Join us"),
      baseColor: "#FFE014",
      secondaryColor: "#F2655C",
      action: handleJoinUs,
      icon: JoinUsSvg,
      animation: <img src={communityGif} width={76} />,
      path: "/support/join/signup",
    },
    {
      title: Translation("How to Upload"),
      desc: Translation("Upload your projects or items for sale with us!"),
      sub: Translation(
        "Can't upload projects, buildings, architecture, condos? We can help."
      ),
      cta: Translation("Upload now"),
      baseColor: "#F0483E",
      secondaryColor: "rgba(255, 255, 255, 0.40)",
      action: handleShareProject,
      icon: UploadSvg,
      animation: <img src={shareGif} width={56} />,
      path: "/support/upload/images",
    },
    // {
    //   title: Translation("How to Tenders"),
    //   desc: Translation("Do you want to find work but don't know..."),
    //   sub: Translation(
    //     "No knowledge of Tendering means no project completion. Got it?"
    //   ),
    //   cta: Translation("Start Tendering"),
    //   baseColor: "#FF E014",
    //   secondaryColor: "#F2655C",
    //   icon: TenderSvg,
    //   animation: <img src={auctionGif} width={56} />,
    //   path: "/support/faqs",
    // },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleSelectNextHowTo = () => {
    setCurrentIndex((curr) => {
      let newNextIndex = curr + 1;

      if (options.length === newNextIndex) {
        newNextIndex = 0;
      }

      return newNextIndex;
    });
  };

  const getOptions = () => {
    let temp = _.cloneDeep(options);
    const optionsToAddToBack = temp.splice(0, currentIndex);
    let _options = [...temp, ...optionsToAddToBack];
    _options.shift();

    return _options;
  };

  const handleReadClick = (path) => {
    navigate(path);
  };

  const isMobile = !["lg", "xl"].includes(screenSize);

  return (
    <div className={`how-to ${isMobile ? "how-to--mobile" : ""}`}>
      {options.map(({ title, desc, sub, icon: Icon, animation, path }) => {
        return (
          <div key={title} className="how-to-option">
            <h3 className="how-to-option__title">{title}</h3>
            <h3 className="how-to-option__desc">{desc}</h3>
            <h4 className="how-to-option__sub">{sub}</h4>
            <div className="how-to-option__icon">
              {animation ? animation : <Icon />}
            </div>
            <div
              className="how-to-option__read"
              onClick={() => handleReadClick(path)}
            >
              <ArrowRightSvg />
              Read more
            </div>
            <div className="how-to-option__separator" />
          </div>
        );
      })}
    </div>
  );
};

HowTo.propTypes = {};

export default HowTo;
